import SwipeableViews from 'react-swipeable-views'
import { bindKeyboard, virtualize } from 'react-swipeable-views-utils'

export const VirtualizeSwipeableViews = bindKeyboard(virtualize(SwipeableViews))
